import { atom } from "recoil";


const productView = atom({
  key: 'productView', 
  default: [1], 
 });


 export default productView;

